import React from "react";
import i18next from "i18next";
import { register } from "frontend/src/api/auth";
import { viewerSet } from "frontend/src/domain/session/model";
import { isValidEmail } from "frontend/src/lib/is-valid-email";
import { locales } from "frontend/src/domain/localization/i18n";
import { Role } from "frontend/src/shared/types/role";
import { useViewerLanguage } from "frontend/src/domain/localization";
var validations = [
    {
        key: "email",
        message: "emailMissing",
        check: function (form) { return form.email.length > 0; },
    },
    {
        key: "password",
        message: "passwordMissing",
        check: function (form) { return form.password.length > 0; },
    },
    {
        key: "email",
        message: "incorrectEmail",
        check: function (form) { return isValidEmail(form.email); },
    },
];
export var usePageModel = function () {
    var _a = React.useState(""), email = _a[0], setEmail = _a[1];
    var _b = React.useState(""), password = _b[0], setPassword = _b[1];
    var _c = React.useState(Role.BusinessOwner), role = _c[0], setRole = _c[1];
    var _d = React.useState(false), isSubmitting = _d[0], setSubmitting = _d[1];
    var _e = React.useState({}), errors = _e[0], setErrors = _e[1];
    var lang = useViewerLanguage();
    var validate = function () {
        var _a;
        var isValid = true;
        var errors = { email: [], password: [] };
        for (var _i = 0, validations_1 = validations; _i < validations_1.length; _i++) {
            var validation = validations_1[_i];
            if (!validation.check({ email: email, password: password })) {
                (_a = errors[validation.key]) === null || _a === void 0 ? void 0 : _a.push(i18next.t("pages.register.errors." + validation.message, {
                    ns: locales.namespaces.guest,
                }));
                isValid = false;
            }
        }
        if (!isValid) {
            setErrors(errors);
        }
        return isValid;
    };
    var submit = function (evt) {
        evt.preventDefault();
        setErrors({});
        if (!validate()) {
            return;
        }
        setSubmitting(true);
        register({ login: email, password: password, role: role, lang: lang })
            .then(function (response) {
            setSubmitting(false);
            if (response.type === "fail") {
                setErrors(response.payload);
            }
            if (response.type === "success") {
                viewerSet(response.payload);
            }
        })
            .catch(function () {
            setSubmitting(false);
            setErrors({ unknown: true });
        });
    };
    var onEmailChange = function (evt) {
        return setEmail(evt.target.value);
    };
    var onPasswordChange = function (evt) {
        return setPassword(evt.target.value);
    };
    var onRoleChange = function (evt) {
        var value = evt.target.value;
        if (value === Role.BusinessOwner || value === Role.Rightholder) {
            setRole(value);
        }
    };
    return {
        submit: submit,
        email: { value: email, onChange: onEmailChange },
        password: { value: password, onChange: onPasswordChange },
        role: { value: role, onChange: onRoleChange },
        errors: errors,
        isSubmitting: isSubmitting,
    };
};
